import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import CheckMark from '../../../../../../new-components/svg-icons/CheckMark';
import { useSelector } from 'react-redux';

interface FilterChipProps {
  id: number;
  name: string;
  isSelected: boolean;
  handleClick: (id: number) => void;
}

interface ContainerProps {
  selected: boolean;
}
const FilterChip = ({ id, name, isSelected, handleClick }: FilterChipProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const isMobile = useSelector((state: any) => state.app.isMobile);

  useEffect(() => {
    if (ref.current) {
      if (isSelected) {
        ref.current.classList.add('selected');
      } else {
        ref.current.classList.remove('selected');
      }
    }
  }, [isSelected]);

  return (
    <Container
      ref={ref}
      selected={isSelected}
      onClick={() => handleClick(id)}
      className={isSelected ? 'selected' : ''}
    >
      {isSelected && !isMobile && <CheckMark />}
      {name}
    </Container>
  );
};

const Container = styled.div<ContainerProps>`
  min-width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 35px;
  padding: 5px 10px;
  border-radius: ${props => props.theme.borderRadius};
  background: #e4ebf2;
  color: #313131;
  font-size: ${props => props.theme.font.sizes.m};
  font-family: materialRegular;
  text-transform: capitalize;
  cursor: pointer;

  &.selected {
    background: #fff !important;
    border: 1px solid #f0f1f3 !important;

    :hover {
      background-color: initial;
    }
  }

  :hover {
    background-color: #e9ebf9;
    scale: 1.01;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    background: #fff;
    border: 1px solid #f0f1f3;
    color: #697586;
    font-size: ${props => props.theme.font.sizes.xxs};

    :hover {
      background-color: initial;
    }

    &.selected {
      background: #e4ebf2 !important;
      border: none;

      :hover {
        background-color: initial;
      }
    }
  }
`;

export default FilterChip;
